import * as palette from "@govlaunch/palette";
import Link from "next/link";
import React from "react";
import { FormattedMessage } from "react-intl";
import { IVendorQuery } from "~/lib/queries/__generated__/VendorQuery.generated";
import GovernmentRichLink from "~/components/government/GovernmentRichLink";
import { ShowMore } from "~/components/profile/ShowMore";

interface IGovernmentConnectionsBoxProps {
  vendor: NonNullable<IVendorQuery["company"]>;
}

export default function GovernmentConnectionsBox({ vendor }: IGovernmentConnectionsBoxProps) {
  const governments =
    vendor.governmentConnections && vendor.governmentConnections.items
      ? vendor.governmentConnections.items.slice(0, 4)
      : [];

  if (!governments) {
    return null;
  }

  if (!vendor.plan.limits.enrichedProfile) {
    return null;
  }

  return (
    <div
      css={{
        backgroundColor: palette.white,
        borderRadius: 5,
        border: `solid 1px ${palette.lightestGray}`,
        position: "relative",
      }}
    >
      <div
        css={{
          padding: 15,
          borderBottom: `solid 1px ${palette.lightestGray}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <span
          css={{
            textTransform: "uppercase",
            fontSize: 12,
            color: palette.sealBlue,
            letterSpacing: 0.5,
            fontWeight: 500,
          }}
        >
          <FormattedMessage
            defaultMessage="Government Connections ({governmentConnectionsCount})" id="C7I5jD"
            values={{
              governmentConnectionsCount: vendor.governmentConnectionsCount,
            }}
          />
        </span>
      </div>

      <div
        css={{
          display: "grid",
          padding: 15,
          gridRowGap: 15,
        }}
      >
        {governments.map((government) => (
          <GovernmentRichLink government={government} key={government._id} />
        ))}
      </div>

      {vendor.governmentConnectionsCount > 4 && (
        <Link href="/vendors/[vendorSlug]/[[...content]]" as={`/vendors/${vendor.slug}/governments`} passHref={true}>
          <a>
            <ShowMore />
          </a>
        </Link>
      )}
    </div>
  );
}
